import React from 'react';
import { Eye, EyeOff, Star, StarOff, ShoppingCart, Trash2, X, Ban } from 'lucide-react';
import { Button } from '../../../components/ui/button';

export const ProductBulkActions = ({ selectedCount, handleBulkAction, deselectAll }) => {
    if (selectedCount === 0) return null;
    return (
        <div className="flex items-center gap-3 p-3 mb-4 rounded-xl bg-jungle/5 border border-jungle/20" data-testid="bulk-actions-bar">
            <span className="text-sm font-medium text-jungle">{selectedCount} selectionne(s)</span>
            <div className="flex gap-2 ml-auto flex-wrap">
                <Button size="sm" variant="outline" onClick={() => handleBulkAction('activate')} className="text-green-600 border-green-300">
                    <Eye className="w-3 h-3 mr-1" /> Activer
                </Button>
                <Button size="sm" variant="outline" onClick={() => handleBulkAction('deactivate')} className="text-amber-600 border-amber-300">
                    <EyeOff className="w-3 h-3 mr-1" /> Masquer
                </Button>
                <Button size="sm" variant="outline" onClick={() => handleBulkAction('weekly_on')} className="text-purple-600 border-purple-300">
                    <Star className="w-3 h-3 mr-1" /> Promo ON
                </Button>
                <Button size="sm" variant="outline" onClick={() => handleBulkAction('weekly_off')} className="text-gray-600 border-gray-300">
                    <StarOff className="w-3 h-3 mr-1" /> Promo OFF
                </Button>
                <Button size="sm" variant="outline" onClick={() => handleBulkAction('orderable_on')} className="text-jungle border-jungle/30">
                    <ShoppingCart className="w-3 h-3 mr-1" /> Pret commande
                </Button>
                <Button size="sm" variant="outline" onClick={() => handleBulkAction('orderable_off')} className="text-red-600 border-red-300">
                    <Ban className="w-3 h-3 mr-1" /> Non pret commande
                </Button>
                <Button size="sm" variant="outline" onClick={() => handleBulkAction('delete')} className="text-red-600 border-red-300">
                    <Trash2 className="w-3 h-3 mr-1" /> Supprimer
                </Button>
                <Button size="sm" variant="ghost" onClick={deselectAll} className="text-muted-foreground">
                    <X className="w-3 h-3 mr-1" /> Annuler
                </Button>
            </div>
        </div>
    );
};
